import React, { useEffect } from 'react';

export default function NewsPage() {
  useEffect(() => {
    // Smoothly scrolls the window to the very top when the component mounts
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <div className="flex h-screen text-3xl font-bold items-center justify-center pt-32">
      This page will be Updated Later
    </div>
  );
}